import script from "./CreateMapModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateMapModal.vue?vue&type=script&setup=true&lang=js"

import "./CreateMapModal.vue?vue&type=style&index=0&id=2bc5106a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bc5106a"]])

export default __exports__